import { useEffect } from "react";
import { useTaskBoardStateContext, useTaskBoardDispatchContext } from "@app/Areas/Optimus/Apps/TaskBoardApp";
import useVaultIdParam from "@app/Areas/Optimus/State/App/NavigationContext/hooks/useVaultIdParam";
import { BOARDS_CLEAR_BOARD_TO_PROTECT, BOARDS_CLEAR_BOARD_UNDER_ARCHIVE } from "../../../state/TaskBoardReducer/TaskBoardReducer";
import useBoardIdParam from "../useBoardIdParam";

function useBoardToProtect() {
    const vaultId = useVaultIdParam();
    const boardId = useBoardIdParam();

    const boardStateContext = useTaskBoardStateContext();
    const boardToProtect = boardStateContext.boards.selectedToProtect;
    const boardDispatch = useTaskBoardDispatchContext();

    useEffect(() => {
        return function cleanup() {
            boardDispatch({
                type: BOARDS_CLEAR_BOARD_TO_PROTECT
            })
        }
    }, [vaultId])

    if (!boardToProtect) {
        return null;
    }

    const board = boardStateContext?.boards?.byId[boardToProtect];

    if (
        !board
        || board.parentVaultId !== vaultId
        || board.board.id !== boardId) {
        return null;
    }

    return board;
}

export default useBoardToProtect;
